// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"d4d0600f","453":"d578867b","455":"77f42366","782":"531f56b3","977":"c946904c"}[chunkId] + ".chunk.js";
};